import type { PresentableTaskResource } from '@timelyapp/integration-cloud-api-spec';

/** Preserve server order while rendering each task identity at most once. */
export const uniqueTaskResourcesByUri = (
  tasks: readonly PresentableTaskResource[]
): PresentableTaskResource[] => {
  const seen = new Set<string>();
  return tasks.filter(task => {
    if (seen.has(task.uri)) return false;
    seen.add(task.uri);
    return true;
  });
};
